export const AppActionType = {
    UPDATE_CURRENT_ACT: 'APP.UPDATE_CURRENT_ACT',
    UPDATE_NETWORK_SPEED: 'APP.UPDATE_NETWORK_SPEED',
    SET_MENU: 'APP.SET_MENU',
    SET_MENU_CONTENT: 'APP.SET_MENU_CONTENT',
    SET_VIDEO: 'APP.SET_VIDEO',
    UPDATE_LANGUAGE: 'APP.UPDATE_LANGUAGE',
    SET_INFO: 'APP.SET_INFO',
    UPDATE_MUTED: 'APP.UPDATE_MUTED',
    UPDATE_CURRENT_SONG: 'APP.UPDATE_CURRENT_SONG',
    UPDATE_CURRENT_SITE: 'APP.UPDATE_CURRENT_SITE',
    SET_CURRENT_STEP: 'APP.SET_CURRENT_STEP',
    SET_CURRENT_COLLECTION: 'APP.SET_CURRENT_COLLECTION',
    SET_CURRENT_GAMA: 'APP.SET_CURRENT_GAMA',
    SET_VISIT: 'APP.SET_VISIT',
    SET_CURRENT_MAP: 'APP.SET_CURRENT_MAP'
}